import { render, staticRenderFns } from "./SectionArraySimple.vue?vue&type=template&id=50f2950a&"
import script from "./SectionArraySimple.vue?vue&type=script&lang=js&"
export * from "./SectionArraySimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f2950a')) {
      api.createRecord('50f2950a', component.options)
    } else {
      api.reload('50f2950a', component.options)
    }
    module.hot.accept("./SectionArraySimple.vue?vue&type=template&id=50f2950a&", function () {
      api.rerender('50f2950a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/FormBuilder/SectionArraySimple.vue"
export default component.exports